import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { db } from '../../../common/firebaseApp';
import GoogleAutoCompleteInput from '../GoogleAutocompleteInput';
import FlatCard from '../FlatCard';

interface IFlat {
  img: string;
  price: number;
  city: string;
  description: string;
  createDate: string;
}

const FlatsScreen: React.FC = () => {
  const docRef = db.collection('flats');
  const [flats, setFlats] = useState<IFlat[]>([]);
  const query = new URLSearchParams(useLocation().search);
  const queryPage = query.get('city');
  let filterFlats = [];
  if (queryPage) {
    filterFlats = flats.filter((flat) => flat.city === queryPage);
  } else {
    filterFlats = flats.sort((current, second) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return current.createDate - second.createDate;
    });
  }
  useEffect(() => {
    async function getFlats() {
      await db
        .collection('flats')
        .get()
        .then((snapshot) => {
          let arr: IFlat[] = [];
          snapshot.docs.forEach((doc) => {
            arr.push(doc.data() as IFlat);
          });
          arr = arr.slice(0, 21);
          setFlats(arr);
        });
    }
    getFlats();
  }, []);

  const onSubmit = async () => {
    await db
      .collection('flats')
      .add({
        img: 'https://picsum.photos/1080/1080',
        price: 55,
        city: 'New York',
        description: '3 quest, 2 bedroom, 2 bed, 1 bath, wifi, kitchen, washer',
        createDate: Date.now(),
      })
      .then((item) => {
        console.log('Document written with ID: ', docRef.id);
      })
      .catch((error) => {
        console.error('Error adding document: ', error);
      });
  };
  return (
    <Box pt={4} px={4}>
      <Box>
        <Button onClick={onSubmit}>Submit</Button>
        <GoogleAutoCompleteInput />
        {filterFlats.map((item) => {
          return (
            <FlatCard
              key={item.createDate}
              img={item.img}
              price={item.price}
              city={item.city}
              description={item.description}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default FlatsScreen;
